import { http } from '../../config/axios'

export default function getRegistroMotivoCancelamento(): Promise<any> {
  return http
    .get('api/registro/motivoscancelamento/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getRegistroMotivoCancelamento', error)
      throw Error(error.response.data)
    })
}
